import React, { FC } from 'react';
import PropTypes from 'prop-types';
import logopic from "../user/images/f-logo.png"
interface ILogoProps {
	width?: number;
	height?: number;
}
const Logo: FC<ILogoProps> = ({ width, height }) => {
	return (
		<img
			src={logopic}
			alt="Webs2pdf logo"
			className="app-logo-wrap" />
	);
};
Logo.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
};
Logo.defaultProps = {
	width: 2155,
	height: 854,
};

export default Logo;
